'use strict';

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var Acl = (function () {
	function Acl(schema) {
		_classCallCheck(this, Acl);

		console.log(schema);
		this.rules = {};
		if (schema) {
			this.addFromSchema(schema);
		}
	}

	Acl.prototype.makeArray = function makeArray(item) {
		if (!item) {
			return [];
		}
		return _lodash2['default'].isArray(item) ? item : [item];
	};

	Acl.prototype.addFromSchema = function addFromSchema(schema) {
		var _this = this;

		_Object$keys(schema).forEach(function (resource) {
			_Object$keys(schema[resource]).forEach(function (role) {
				_this.addPermissions(role, resource, schema[resource][role]);
			});
		});
	};

	Acl.prototype.addPermissions = function addPermissions(role, resource, permissions) {
		if (!this.rules[role] || !this.rules[role][resource]) {
			if (!this.rules[role]) {
				this.rules[role] = {};
			}
			this.rules[role][resource] = [];
		}
		this.rules[role][resource] = _lodash2['default'].union(this.rules[role][resource], permissions);
	};

	Acl.prototype.allow = function allow(roles, resources, permissions) {
		var _this2 = this;

		roles = this.makeArray(roles);
		resources = this.makeArray(resources);
		permissions = this.makeArray(permissions);

		roles.forEach(function (role) {
			resources.forEach(function (resource) {
				_this2.addPermissions(role, resource, permissions);
			});
		});
	};

	Acl.prototype._isAllowed = function _isAllowed(roles, resources, permissions) {
		var _this3 = this;

		var all = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

		roles = this.makeArray(roles);
		resources = this.makeArray(resources);
		permissions = this.makeArray(permissions);

		var isValid = undefined;

		roles.forEach(function (role) {
			resources.forEach(function (resource) {
				permissions.forEach(function (permission) {
					if (isValid === true || all === true && isValid === false) {
						return true;
					}
					if (_this3.rules[role] && _this3.rules[role][resource]) {
						isValid = _this3.rules[role][resource].indexOf(permission) !== -1 || _this3.rules[role][resource].length == 0;
					} else {
						isValid = false;
					}
				});
			});
		});
		return isValid;
	};

	Acl.prototype.isAllowed = function isAllowed(roles, resources, permission) {
		return this._isAllowed(roles, resources, permission);
	};

	return Acl;
})();

exports['default'] = Acl;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-acl/src/Acl.js
 ** module id = 981
 ** module chunks = 1
 **/